
import React from 'react';


const Cher = () => {
    const handleClick = () => {
        window.open('https://cherahome.com/', '_blank');
    };

    return (
        <button
            onClick={handleClick}
            className="w-12 h-12 bg-contain bg-no-repeat bg-center hover:scale-110 transition-opacity dark:invert"
            style={{ backgroundImage: "url('/arrow.svg')" }}
            aria-label="arrow"
        />
    );
};

export default Cher;